  
<div style="overflow-x:auto;height: calc(100vh - 86px)">
  
  <app-scout-path-points-table #pathPointsTable
    [scoutTaskDoc]="scoutTaskDoc" [detailFn]="detailFn" (contextJsonChange)="onChildContextChange($event,pathPointsTable)">
  </app-scout-path-points-table>

  <div class="p-1">    
  </div>

  <app-scout-building-points-table #buildingPointsTable
    [scoutTaskDoc]="scoutTaskDoc" [detailFn]="detailFn" (contextJsonChange)="onChildContextChange($event,buildingPointsTable)">
  </app-scout-building-points-table>

  <div class="p-1">    
  </div>
  
  <div class="p-2">
    <div class="font-weight-bold">Path Test Point Parameters</div>
    <app-path-point-parameters-table #pathPointParamTable
      [scoutTask]="scoutTaskDoc" 
      [scoutPathIds]="pathIds"
      [tableClasses]="['table-view-table']"
      [detailFn]="detailFn">
    </app-path-point-parameters-table>
  </div>
</div>
